import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Popover} from "react-bootstrap";

class ContactsPopover extends Component {
    static propTypes = {
        contacts: PropTypes.array.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const {contacts, close, ...props} = this.props;
        return (
            <Popover {...props} style={{width: '500px', minWidth: '500px'}}>
                <table className="table">
                    <thead>
                    <tr>
                        <th>Контактное лицо</th>
                        <th>Телефон</th>
                        <th>Email</th>
                    </tr>
                    </thead>
                    <tbody>
                    {contacts.map((contact, i) =>
                        <tr key={i}>
                            <td>{contact.name}</td>
                            <td>{contact.phoneNumber}</td>
                            <td>
                                {
                                    contact.email &&
                                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                                }
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
                <div className="clearfix">
                    <button type="button" className="btn btn-default btn-3d"
                            onClick={() => close()}>
                        Закрыть
                    </button>
                </div>
            </Popover>
        );
    }
}

export default ContactsPopover;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/Tenders/modals/popovers/ContactsPopover.js